// src/App.tsx
import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingWhatsApp from './components/FloatingWhatsApp';

import HomePage from './pages/HomePage';

const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const CataloguesPage = lazy(() => import('./pages/CataloguePage'));

function App() {
  // Preload lazy pages after initial mount
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        import('./pages/ProductsPage');
        import('./pages/ContactPage');
        import('./pages/AboutPage');
        import('./pages/CataloguePage');
      });
    } else {
      import('./pages/ProductsPage');
      import('./pages/ContactPage');
      import('./pages/AboutPage');
      import('./pages/CataloguePage');
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white flex flex-col">
        <Header />

        <main className="flex-grow">
          <Suspense
            fallback={
              <div className="flex flex-col items-center justify-center h-screen bg-white">
                <img
                  decoding="async"
                  src="/Asus_logo.png"
                  alt="Asus"
                  className="h-20 w-auto object-contain animate-pulse mb-3"
                />
                <p className="text-gray-500 animate-pulse">
                  Loading, please wait...
                </p>
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/contact-us" element={<ContactPage />} />
              <Route path='/catalogues' element={<CataloguesPage />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default App;
